import styled from 'styled-components'
import { Collapse, Switch, Input } from 'antd'
import { desktop } from '../../globalAssets/fontsize'
import { device } from '../../globalAssets/breakpoints'
export const Container = styled.div`
  width: 100%;
  height: 100%;
  /* background: ${(props) => props.theme.foreground}; */
  /* box-shadow: ${(props) => props.theme.subtleShadow}; */
  padding: 2vw;
`
export const InfoDiv = styled.div`
  width: 100%;
  & > h3 {
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    color: ${(props) => props.theme.grey};
    margin: 0;
    border-bottom: ${(props) => `1px solid${props.theme.grey}`};
  }
  & > h2 {
    font-size: 15px;
    margin: 0;

    font-weight: 600;
    margin-top: 0.6vw;
    color: ${(props) => props.theme.grey};
    span {
      color: ${(props) => props.theme.primaryColor};
      /* text-transform: capitalize; */
    }
  }
  h5 {
    color: ${(props) => props.theme.grey};
    font-size: 14px;
    text-align: end;
  }
  @media ${device.laptop} {
    & > h3 {
      font-size: ${desktop.small};
    }
    & > h2 {
      font-size: 0.9vw;

      h5 {
        font-size: 0.8vw;
        text-align: end;
      }
    }
  }
`
export const MobileNameBar = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: baseline;
  & > h3 {
    margin: 0;
    color: ${(props) => props.theme.color};
    font-size: 20px;
    text-transform: capitalize;
    margin-right: 1.5vw;
    font-weight: 600;
  }
  & > h2 {
    display: flex;
    align-items: center;
    margin: 0;
    font-weight: 400;
    color: ${(props) => props.theme.grey};
    font-size: 14px;
    span {
      margin-left: 0.3vw;
    }
  }
  @media ${device.laptop} {
    display: none;
  }
`
export const NameBar = styled.div`
  display: none;
  @media ${device.laptop} {
    display: flex;
    align-items: baseline;
    & > h3 {
      margin: 0;
      color: ${(props) => props.theme.color};
      font-size: 1.8vw;
      text-transform: capitalize;
      margin-right: 1.5vw;
      font-weight: 600;
    }
    & > h2 {
      display: flex;
      align-items: center;
      margin: 0;
      font-weight: 400;
      color: ${(props) => props.theme.grey};
      font-size: ${desktop.normal};
      span {
        margin-left: 0.3vw;
      }
    }
  }
`

export const StyledCollapse = styled(Collapse)`
  background: ${(props) => props.theme.background};
  /* margin-top: 10px; */
  border: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  .ant-collapse-content-box {
    background: ${(props) => props.theme.tableHighlight} !important;
    border: none !important;
  }
  .ant-collapse-item,
  .ant-collapse-content-active {
    border: none;
  }
  svg,
  .ant-collapse-header {
    color: ${(props) => props.theme.color} !important;
    /* font-size: ${desktop.normal}; */
    border: none;
  }
`

export const StyledPanel = styled(Collapse.Panel)`
  background: ${(props) => props.theme.background} !important;
  border: none;
`
export const Delete = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 7px;
  h5 {
    color: ${(props) => props.theme.color};
    margin: 0 0 0 5px;
    font-size: 12px;
  }
  h1 {
    color: red;
    margin: 0 0 0 5px;
    font-size: 15px;
    display: flex;
    align-items: center;
  }
  @media ${device.laptop} {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0.5vw 1vw;
    h5 {
      font-size: ${desktop.medium};
    }
    h1 {
      font-size: ${desktop.normal};
    }
  }
`

export const StyledSwitch = styled(Switch)`
  font-size: ${desktop.normal};
  /* background-color: ${(props) => props.theme.background}; */
`
export const ModalContent = styled.div`
  width: 100%;
  & > h3 {
    font-size: 14px;
    text-align: center;
    margin: 0;
    color: ${(props) => props.theme.color};
    span {
      color: ${(props) => props.theme.primaryColor};
    }
  }
  div {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    button {
      font-size: 15px;
      color: ${(props) => props.theme.white};
      background: red;
      outline: none;
      border: none;
      border-radius: 2px;
      cursor: pointer;
    }
  }
  @media ${device.laptop} {
    width: 100%;
    padding: 0.5vw 0;
    & > h3 {
      font-size: ${desktop.small};
    }
    div {
      padding: 1vw;
      button {
        font-size: ${desktop.small};
      }
    }
  }
`

export const StyledInput = styled(Input.TextArea)`
  &&& {
    width: '100%';
    ${'' /* height: 15px; */}
    ${'' /* cursor: pointer; */}
    /* transition: ease-in all 0.3s; */
    padding-left: 10px;
    outline: none;
    font-size: 14px;
    overflow-y: auto;
    /* background: none; */
    border: 1px solid ${(props) => props.theme.subtleBlack};
    background: ${(props) => props.theme.foreground};

    color: ${(props) => props.theme.color};

    .ant-input {
      background: ${(props) => props.theme.background};
      color: ${(props) => props.theme.color};
      font-size: ${desktop.normal};
    }
    :active,
    :focus,
    :hover {
      border: 1px solid ${(props) => props.theme.primaryColor};
    }
  }
`

export const PhoneDiv = styled.div`
  .containerStyle {
    background: ${(props) => props.theme.foreground} !important;
    width: 100% !important;
    border: 1px solid ${(props) => props.theme.subtleBlack};
    :active,
    :focus,
    :hover {
      border: 1px solid ${(props) => props.theme.primaryColor};
    }
    .inputStyle {
      background: ${(props) => props.theme.foreground} !important;
      border: none !important;
      color: ${(props) => props.theme.color};
      width: 100% !important;
      font-size: 14px;
      :active,
      :focus,
      :hover {
        border: 1px solid ${(props) => props.theme.primaryColor};
      }
    }
    .dropdownStyle {
      background: ${(props) => props.theme.foreground} !important;
      border: none !important;
      color: ${(props) => props.theme.color};
      font-size: 14px;
      :active,
      :focus,
      :hover {
        border: 1px solid ${(props) => props.theme.primaryColor};
        background: ${(props) => props.theme.foreground} !important;
        color: ${(props) => props.theme.color};
      }
    }
    .buttonStyle {
      background: ${(props) => props.theme.foreground} !important;
      border: none;
      border-right: 1px solid ${(props) => props.theme.black};
      color: ${(props) => props.theme.color};
      font-style: 14px;
      :active,
      :focus,
      :hover {
        background: ${(props) => props.theme.foreground} !important;
      }
    }
    .searchStyle {
      background: ${(props) => props.theme.foreground} !important;
      border: none;
      border-right: 1px solid ${(props) => props.theme.black};
      color: ${(props) => props.theme.color};
      font-size: 14px;
      :active,
      :focus,
      :hover {
        background: ${(props) => props.theme.foreground} !important;
      }
    }
    @media ${device.laptop} {
      .inputStyle {
        font-size: ${desktop.small};
      }
      .dropdownStyle {
        /* width: 100% !important; */
        font-size: ${desktop.small};
      }
      .buttonStyle {
        /* width: 100% !important; */
        font-size: ${desktop.small};
      }
      .searchStyle {
        /* width: 100% !important; */
        font-size: ${desktop.small};
      }
    }
  }
`
export const PreferencesText = styled.p`
  padding: 2px;
  background-color: ${(props) => props.theme?.subtleGrey};
  color: ${(props) => props.theme.color};
  margin: 4px;
`
